import React, { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

interface Props {
  buttonLeft?: ReactNode;
  buttonRight?: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  statementNavigationContainer: {
    padding: "10px 5px 0px 5px",
  },
}));

export default function StatementNavigationContainer({
  buttonLeft = null,
  buttonRight = null,
}: Props) {
  const classes = useStyles();

  return (
    <Grid container item direction="row" justify="space-between">
      <Grid className={classes.statementNavigationContainer}>{buttonLeft}</Grid>
      <Grid className={classes.statementNavigationContainer}>
        {buttonRight}
      </Grid>
    </Grid>
  );
}
